export default __webpack_public_path__ + "static/media/ecosystem_log2.620a0e05.png";